/** Per-session baseline timestamp for artifact summaries (start of current/last run). */
export function markChatRunArtifactsBaseline(
  baselines: Record<string, number>,
  sessionKey: string,
  sinceTs: number,
): Record<string, number> {
  const key = sessionKey.trim();
  if (!key) {
    return baselines;
  }
  return { ...baselines, [key]: sinceTs };
}

export function getChatRunArtifactsSinceTs(
  baselines: Record<string, number>,
  sessionKey: string,
): number | undefined {
  const key = sessionKey.trim();
  if (!key) {
    return undefined;
  }
  const value = baselines[key];
  return typeof value === "number" && Number.isFinite(value) ? value : undefined;
}

export function clearChatRunArtifactsBaseline(
  baselines: Record<string, number>,
  sessionKey: string,
): Record<string, number> {
  const key = sessionKey.trim();
  if (!baselines[key]) {
    return baselines;
  }
  const next = { ...baselines };
  delete next[key];
  return next;
}

export function clearFileChangesNoticeForSession(
  notified: Record<string, string>,
  sessionKey: string,
): Record<string, string> {
  const key = sessionKey.trim();
  if (!notified[key]) {
    return notified;
  }
  const next = { ...notified };
  delete next[key];
  return next;
}
